import { MapTemplate } from "./MapTemplate";
import { LegendTemplate } from "./LegendTemplate";
import { PrintInfo } from "../../../interfaces/print";

export class TemplateFactory {
  constructor(private readonly printInfo: PrintInfo) {}

  async mapTemplate() {
    return new MapTemplate(this.printInfo).serialize();
  }

  async legendTemplate() {
    return new LegendTemplate(this.printInfo).serialize();
  }
}
